// extracted by mini-css-extract-plugin
module.exports = {"button":"EditDataField_button__VbfTj","eventsSelector":"EditDataField_eventsSelector__1aODM","sponsorsLayoutBackground":"EditDataField_sponsorsLayoutBackground__tZo7g"};